import { useQuery } from '@tanstack/react-query'

import { fetchEventBranding, fetchQuests, fetchQuizPlay } from './api'

export const useQuestsQuery = (eventSlug: string) =>
  useQuery({
    queryKey: ['public-quests', eventSlug],
    queryFn: () => fetchQuests(eventSlug),
    enabled: !!eventSlug,
    retry: 3,
    refetchOnWindowFocus: false
  })

export const useQuizPlayQuery = (eventSlug: string, questUid: string, runId: number | null) =>
  useQuery({
    queryKey: ['quest-quiz-play', eventSlug, questUid, runId],
    queryFn: () => fetchQuizPlay(eventSlug, questUid, runId as number),
    enabled: !!runId,
    refetchOnWindowFocus: false
  })

export const useEventBrandingQuery = (eventSlug: string) =>
  useQuery({
    queryKey: ['quest-event-branding', eventSlug],
    queryFn: () => fetchEventBranding(eventSlug),
    enabled: !!eventSlug,
    staleTime: 60_000,
    refetchOnWindowFocus: false
  })
